import React from "react";
import { FilterIcon } from "./Icons";

export const ToggleFiltersButton = ({ showFilters, onToggle }) => {
	if (showFilters) return null;

	return (
		<button
			onClick={onToggle}
			className="btn btn-primary btn-medium toggle-filters-btn"
		>
			<FilterIcon />
		</button>
	);
};
